import styled from 'styled-components'

export const LogoAndBackgroundImageWrapper = styled.div``
export const LogoImageWrapper = styled.div``
export const BackgroundImageWrapper = styled.div``
export const ProjectImagesWrapper = styled.div``
export const PanelContentWrapper = styled.div``
